<script lang="ts" setup>
import { onBeforeUnmount, onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import NavUserPopup from './NavUserPopup.vue'
import TopUpPopup from './TopUpPopup.vue'
import MembershipPopup from './MembershipPopup.vue'
import LoginPopup from './LoginPopup.vue'
import { useUserStore } from '@/stores/user'

const route = useRoute()
const router = useRouter()
const userStore = useUserStore()
const popupVisible = ref(false)
const showTopUpPopup = ref(false)
const showMembershipPopup = ref(false)
const showLoginPopup = ref(false)
const containerRef = ref<HTMLElement>()

function togglePopup() {
  popupVisible.value = !popupVisible.value
}

function handleClickOutside(e: MouseEvent) {
  const target = e.target as Node
  const popup = document.querySelector('.nav-user-popup')
  if (containerRef.value && !containerRef.value.contains(target) && !(popup && popup.contains(target)))
    popupVisible.value = false
}

function handleTopUp() {
  popupVisible.value = false
  showTopUpPopup.value = true
}

function handleDetails() {
  popupVisible.value = false
  showMembershipPopup.value = true
}

function handleNavigate() {
  popupVisible.value = false
}

function handleSignin() {
  popupVisible.value = false
  showLoginPopup.value = true
}

onMounted(async () => {
  document.addEventListener('click', handleClickOutside)
  // 支付成功后返回时，刷新用户信息
  if (route.query.payment_status === 'success') {
    await userStore.fetchUserInfo()
    const query = { ...route.query }
    delete query.payment_status
    router.replace({ query }).catch(() => {})
  }
})

onBeforeUnmount(() => {
  document.removeEventListener('click', handleClickOutside)
})
</script>

<template>
  <div class="flex items-center" style="gap: 24px">
    <RouterLink
      to="/history"
      class="flex items-center"
      style="gap: 6px; font-weight: 500; font-size: 16px; color: #323435; text-decoration: none"
    >
      <img src="@/assets/icons/library-nav.png" alt="Library" style="width: 18px; height: 18px">
      Library
    </RouterLink>

    <div ref="containerRef">
      <button
        class="nav-user-trigger"
        style="width: 40px; height: 40px; border-radius: 50%; background: transparent; border: none; cursor: pointer; padding: 0; overflow: hidden; display: flex; align-items: center; justify-content: center;"
        @click.stop="togglePopup"
      >
        <img
          v-if="userStore.userInfo?.headImageUrl"
          :src="userStore.userInfo.thirdHeadImgUrl"
          alt="avatar"
          style="width: 100%; height: 100%; object-fit: cover; border-radius: 50%;"
        >
        <img
          v-else
          src="/images/rocnovel/user-default.png"
          alt="avatar"
          style="width: 100%; height: 100%; object-fit: cover; border-radius: 50%;"
        >
      </button>

      <NavUserPopup v-if="popupVisible" :user-info="userStore.userInfo" @topup="handleTopUp" @details="handleDetails" @navigate="handleNavigate" @signin="handleSignin" />
    </div>

    <TopUpPopup v-if="showTopUpPopup" :visible="showTopUpPopup" @close="showTopUpPopup = false" />
    <MembershipPopup v-if="showMembershipPopup" :visible="showMembershipPopup" @close="showMembershipPopup = false" />
    <LoginPopup v-if="showLoginPopup" :visible="showLoginPopup" @close="showLoginPopup = false" />
  </div>
</template>
